export default class Parsers {
  static Week = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

  static Months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  static MonthsShort = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

  static parseMonth(target) {
    return typeof target === "number" && target >= 0 && Parsers.Months.length > target ? Parsers.Months[target] : "N/A";
  }
  static parseMonthShort(target) {
    return typeof target === "number" && target >= 0 && Parsers.MonthsShort.length > target ? Parsers.MonthsShort[target] : "N/A";
  }

  static parseUpperCase(target) {
    return typeof target === "string" ? target.replace(/(^[a-z]|\s[a-z])/g, (t) => { return t.toUpperCase() }) : "";
  }
  static parseLowerCase(target) {
    return typeof target === "string" ? target.toLowerCase() : "";
  }

  static parseDoubleDigit(target) {
    var r = "" + target;
    return r.length < 1 ? "00" : r.length == 1 ? "0" + r : r;
  }

  static parseMoney(value) {
    var r = value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    return r;
  }

  static parseNumber(value, isInteger) {
    var m = typeof value === "number" ? "" + value : typeof value === "string" ? value : "0", r = "", c = 0;
    m = m.replace(',', '.').split(".");
    if (m.length < 2)
      m = [m[0], "0"];
    m = [
      "" + (isNaN(m[0]) ? 0 : parseInt(m[0])),
      "" + (isNaN(m[0]) ? 0 : parseInt(m[1]))
    ];
    var m1 = "";
    for (var i = m[0].length - 1; i >= 0; i--) {
      c++;
      if (c == 4) {
        c = 0;
        m1 = "." + m1;
      }
      m1 = m[0][i] + m1;
    }
    if (isInteger == true)
      r = m1;
    else {
      r += m1 + ",";
      r += this.leftZero(m[1]);
    }
    return r;
  }

  static parseNumberSemZero(value, isInteger) {
    var m = typeof value === "number" ? "" + value : typeof value === "string" ? value : "0", r = "", c = 0;
    m = m.replace(',', '.').split(".");
    if (m.length < 2)
      m = [m[0], "0"];
    m = [
      "" + (isNaN(m[0]) ? 0 : parseInt(m[0])),
      "" + (isNaN(m[0]) ? 0 : parseInt(m[1]))
    ];
    var m1 = "";
    for (var i = m[0].length - 1; i >= 0; i--) {
      c++;
      if (c == 4) {
        c = 0;
        m1 = "." + m1;
      }
      m1 = m[0][i] + m1;
    }
    if (isInteger == true)
      r = m1;
    else {
      r += m1;
    }
    return r;
  }


  static leftZero(target) {
    var t = "" + target;
    if (t.length == 1)
      return t + "0";
    return t;
  }

  static parseCPNJ(target) {
    var r = ("" + target).replace(/[^0-9]/ig, "").substring(0, 14);;
    r = r.replace(/(^[0-9]{2}(?=[0-9]{12})|[0-9]{3}(?=[0-9]{9}))/ig, (t) => {
      return t + ".";
    }).replace(/[0-9]{4}(?=[0-9]{2}$)/ig, (t) => {
      return "/" + t;
    }).replace(/[0-9]{2}$/ig, (t) => {
      return "-" + t;
    });
    return r;
  }

  static parseCPF(target) {
    var r = "" + target;
    r = r.replace(/[^0-9]/ig, "").substring(0, 11);
    r = r.replace(/(^[0-9]{3}(?=[0-9]{7})|[0-9]{3}(?=[0-9]{5}))/ig, (t) => {
      return t + ".";
    }).replace(/[0-9]{2}$/ig, (t) => {
      return "-" + t;
    });
    return r;
  }

  static parseAddress(target) {
    var r = "" + target.placeName + ", " + target.placeNumber + ". " + target.complement + ". CEP: " + target.cep + ", " + target.neighborhood;
    return r;
  }

  static parseAddressCity(target) {
    var r = "" + target.locality + " / " + target.state.description;
    return r;
  }

  static parseDayWeek(target) {
    var r = "" + target, d = target;
    if (typeof d === "object" && d instanceof Date)
      d = d.getDay()
    if (/^[0-9]{4}(-[0-9]{2}){2}T[0-9]{2}(:[0-9]{2}){2}/ig.test(r)) {
      r = r.substr(0, 19);
      var t = r.split(/t/ig);
      t = t[0].split("-");
      d = (new Date(parseInt(t[0]), parseInt(t[1]) - 1, parseInt(t[2]))).getDay();
    }
    if (typeof d === "number" && Parsers.Week.length > d)
      return Parsers.Week[d];
    return "N/A";
  }

  static parseDate(target, ignore) {
    var r = "" + target;
    if (/^[0-9]{4}(-[0-9]{2}){2}T[0-9]{2}(:[0-9]{2}){2}/ig.test(r)) {
      r = r.substr(0, 19);
      var t = r.split(/t/ig);
      var d = t[0].split("-");
      r = ignore == "time" ? "" : t[1];
      if (ignore != "date") r += (ignore !== "time" ? " - " : "") + d[2] + "/" + d[1] + "/" + d[0];
      return r;
    }
    return "N/A";
  }

  static parseSize(target) {
    if (typeof target !== "number") return "0 Bytes";
    var marker = 1024; // Change to 1000 if required
    var decimal = 3; // Change as required
    var kiloBytes = marker; // One Kilobyte is 1024 bytes
    var megaBytes = marker * marker; // One MB is 1024 KB
    var gigaBytes = marker * marker * marker; // One GB is 1024 MB
    var teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if (target < kiloBytes) return target + " Bytes";
    // return KB if less than a MB
    else if (target < megaBytes) return (target / kiloBytes).toFixed(decimal) + " KB";
    // return MB if less than a GB
    else if (target < gigaBytes) return (target / megaBytes).toFixed(decimal) + " MB";
    // return GB if less than a TB
    else return (target / gigaBytes).toFixed(decimal) + " GB";
  }

  static parseDateLabel(target) {
    var r = "" + target;
    if (/^[0-9]{4}(-[0-9]{2}){2}T[0-9]{2}(:[0-9]{2}){2}/ig.test(r)) {
      r = r.substr(0, 19);
      var t = r.split(/t/ig);
      var d = t[0].split("-");
      for (let i = 0; i < d.length; i++)
        d[i] = parseInt(d[i]);
      if (d.length == 3 && d[1] > 0 && Parsers.MonthsShort.length >= d[1])
        return Parsers.MonthsShort[d[1] - 1] + "/" + d[0];
    }
    return "N/A";
  }

  static normalizeNumber(target, ignore) {
    var r = "" + target;
    r = r.replace(/(,|\.)(?![0-9]+$)/ig, "").replace(/[\.\,]/ig, ".");
    r = parseFloat(r);
    return isNaN(r) ? 0 : r;
  }

  static parsePermission(target, company) {
    var v = global.user;
    var p = Array.isArray(target) ? target : typeof target === "string" ? [target] : null;
    var r = false;
    if (p != null && v != null && Array.isArray(v.personPermissionGroupMainPerson)) {
      for (let i = 0; i < v.personPermissionGroupMainPerson.length && r != true; i++)
        for (let j = 0; j < p.length && r != true; j++)
          if (typeof v.personPermissionGroupMainPerson[i].logicalApGroups === "object" && v.personPermissionGroupMainPerson[i].logicalApGroups != null)
            if (v.personPermissionGroupMainPerson[i].logicalApGroups.name == p[j] &&
              typeof company !== "string" ||
              (v.personPermissionGroupMainPerson[i].mainCompany != null && v.personPermissionGroupMainPerson[i].mainCompany.keyRegister == company))
              r = true;
    }
    return r;
  }
  static parsePermission2(target) {
    //console.log(global.permissions)
    var v = global.permissions;
    var p = Array.isArray(target) ? target : typeof target === "string" ? [target] : null;
    var r = false;
    if (p != null && v != null) {
      for (let j = 0; j < p.length && r != true; j++)
        for (var i in v)
          if (i == p[j])
            r = true;
    }
    return r;
  }

  static GetStatusColor(target, type) {
    var r = null;
    switch (type) {
      case "invoice":
        r = target == 10 ? "#1a47dc" : null;
        break;
      default:
    }
    if (r != null) return r;
    return target == 1 || target == 2 || target == 40 || target == 41 ? "#dc821a" :
      target == 3 || target == 42 || target == 44 ? "#dc551a" :
        target == 4 || target == 46 || target == 47 ? "#1a8fdc" :
          target == 5 ? "#1a8fdc" :
            target == 6 || target == 48 ? "#1a47dc" :
              target == 10 || target == 49 ? "#0c6d11" :
                target == 11 ? "#1a8fdc" :
                  target == 12 ? "#0c6d11" : "#982828";
  }

  static GetStatusIcon(target) {
    return target == 1 || target == 2 || target == 40 || target == 41 ? "exclamation-triangle" :
      target == 3 || target == 42 || target == 44 ? "info-circle" :
        target == 4 ? "clock" :
          target == 5 || target == 48 ? "clock" :
            target == 6 || target == 46 || target == 47 ? "user-clock" :
              target == 9 ? "ban" :
                target == 10 || target == 49 ? "check-circle" :
                  target == 11 ? "clock" :
                    target == 12 ? "check-circle" : "times-circle"
  }
  static GOAL_STATUS =
    {
      GOAL_CREATED: 40,
      GOAL_EDITED: 41,
      GOAL_PUBLISHED: 42,
      GOAL_DECLINED_GF: 43,
      GOAL_APPROVE_GF: 44,
      GOAL_DECLINED_GDM: 45,
      GOAL_APPROVE_GDM: 46,
      GOAL_APPROVE_CUSTOMER_USER: 47,
      GOAL_APPROVE_CUSTOMER_ADMIN: 48,
      GOAL_ACCEPT: 49,
    };
  static GOAL_PERMISSIONS =
    {
      GOAL_LISTING: "GOAL_LISTING",
      GOAL_ACCESS: "GOAL_ACCESS",
      GOAL_CREATION: "GOAL_CREATION",
      GOAL_EDIT: "GOAL_EDIT",
      GOAL_DELETE: "GOAL_DELETE",
      GOAL_PUBLISH: "GOAL_PUBLISH",
      GOAL_APPROVAL_GDM: "GOAL_APPROVAL_GDM",
      GOAL_DECLINE: "GOAL_DECLINE",
      GOAL_APPROVAL_GF: "GOAL_APPROVAL_GF",
      GOAL_RELEASE: "GOAL_RELEASE",
      GOAL_APPROVE_CUSTOMER_ADMIN: "GOAL_APPROVE_CUSTOMER_ADMIN",
      GOAL_APPROVE_CUSTOMER_USER: "GOAL_APPROVE_CUSTOMER_USER",
      GOAL_ACCEPT: "GOAL_ACCEPT"
    };
  static PROGRAM_PERMISSIONS = {
    PROGRAM_LIST: "PROGRAM_LIST",
    PROGRAM_CREATION: "PROGRAM_CREATION",
    PROGRAM_PUBLISH: "PROGRAM_PUBLISH",
    PROGRAM_EDIT: "PROGRAM_EDIT",
    PROGRAM_DELETE: "PROGRAM_DELETE",
    PROGRAM_RELEASE: "PROGRAM_RELEASE",
    PROGRAM_ACCESS: "PROGRAM_ACCESS",
    QAWARD_CREATION: "QAWARD_CREATION",
    QAWARD_EDIT: "QAWARD_EDIT",
    ACTION_PLAN_LISTING: "ACTION_PLAN_LISTING",
    ACTION_PLAN_CREATION: "ACTION_PLAN_CREATION",
    ACTION_PLAN_EDIT: "ACTION_PLAN_EDIT",
    ACTION_PLAN_ACCESSING: "ACTION_PLAN_ACCESSING",
    INVOICE_CREATION: "INVOICE_CREATION",
    INVOICE_LISTING: "INVOICE_LISTING",
    INVOICE_EDIT: "INVOICE_EDIT",
    INVOICE_ACCESSING: "INVOICE_ACCESSING",
    ACTION_PLAN_APPROVE: "ACTION_PLAN_APPROVE",
    ACTION_PLAN_DECLINE: "ACTION_PLAN_DECLINE",
    ACTION_PLAN_DELETE: "ACTION_PLAN_DELETE",
    CUSTOMER_RESULT_APPROVE: "CUSTOMER_RESULT_APPROVE",
    CUSTOMER_RESULT_DECLINE: "CUSTOMER_RESULT_DECLINE",
    CUSTOMER_RESULT_CREATION: "CUSTOMER_RESULT_CREATION",
    CUSTOMER_RESULT_EDIT: "CUSTOMER_RESULT_EDIT",
    INVOICE_APPROVE: "INVOICE_APPROVE",
    INVOICE_DECLINE: "INVOICE_DECLINE",
    INVOICE_PAYMENT: "INVOICE_PAYMENT",
    CONFIGURATION_REGIONAL_LIST: "CONFIGURATION_REGIONAL_LIST",
    CONFIGURATION_REGIONAL_EDIT: "CONFIGURATION_REGIONAL_EDIT",
    CONFIGURATION_REGIONAL_CREATION: "CONFIGURATION_REGIONAL_CREATION",
    CONFIGURATION_REGIONAL_DELETE: "CONFIGURATION_REGIONAL_DELETE",
    CONFIGURATION_REGIONAL_ACCESSING: "CONFIGURATION_REGIONAL_ACCESSING",
    CONFIGURATION_TREATMENT_LIST: "CONFIGURATION_TREATMENT_LIST",
    CONFIGURATION_TREATMENT_EDIT: "CONFIGURATION_TREATMENT_EDIT",
    CONFIGURATION_TREATMENT_DELETE: "CONFIGURATION_TREATMENT_DELETE",
    CONFIGURATION_TREATMENT_CREATION: "CONFIGURATION_TREATMENT_CREATION",
    CONFIGURATION_USERS_LIST: "CONFIGURATION_USERS_LIST",
    CONFIGURATION: "CONFIGURATION",
    CONFIGURATION_USERS_CREATION: "CONFIGURATION_USERS_CREATION",
    CONFIGURATION_USERS_DELETE: "CONFIGURATION_USERS_DELETE",
    CONFIGURATION_USERS_EDIT: "CONFIGURATION_USERS_EDIT",
    CONFIGURATION_USERS_ACCESSING: "CONFIGURATION_USERS_ACCESSING",
    COMPANY_LIST: "COMPANY_LIST",
    COMPANY_ACCESSING: "COMPANY_ACCESSING",
    COMPANY_EDIT: "COMPANY_EDIT",
    CONFIGURATION_SALES_HISTORY_UPLOAD: "CONFIGURATION_SALES_HISTORY_UPLOAD",
    QAWARD_ACCESS: "QAWARD_ACCESS"
  };
}